import React from 'react'

export const PageNotFound = () => (
  <div className={'page-not-found text-center'}>
    <h1>404</h1>
    <p>Page not found</p>
    <i className="material-icons">&#xE87B;</i>
  </div>
);

export default PageNotFound



// WEBPACK FOOTER //
// ./src/routes/PageNotFound/components/PageNotFound.js